import { pgTable, uuid, text, timestamp, primaryKey } from "drizzle-orm/pg-core";
import { adminUsers } from "./admin-users.js";

export const staffNotificationSeen = pgTable(
  "staff_notification_seen",
  {
    userId: uuid("user_id")
      .notNull()
      .references(() => adminUsers.id, { onDelete: "cascade" }),
    notificationType: text("notification_type").notNull(),
    lastSeenAt: timestamp("last_seen_at", { withTimezone: true }).notNull().defaultNow(),
  },
  (t) => ({
    pk: primaryKey({ columns: [t.userId, t.notificationType] }),
  }),
);

export type StaffNotificationSeen = typeof staffNotificationSeen.$inferSelect;
export type NewStaffNotificationSeen = typeof staffNotificationSeen.$inferInsert;
